import React from 'react';
import { connect } from 'react-redux';

import Button from '@/src/shared/components/Button';
import Form from '@/src/shared/components/Form';
import RequiredFields from '@/src/shared/components/RequiredFields';
import { space } from '@/styles';

import submitQuestion from '../../redux/actions';
import FormFields from './FormFields';

const { m } = space;

const AskUsForm = props => {
  const { data, form, user, defaultSubject } = props;

  const submit = async e => {
    if (e && 'preventDefault' in e) e.preventDefault();
    window.scrollTo({ top: 0 });
    await form.validateFieldsAndScroll(async (err, values) => {
      if (err) throw err;
      const payload = {
        ...values,
        personId: user.PersonID,
        name: user.FullName,
        phone: user.WorkPhone,
        emailAddress: user.EmailAddress,
      };
      props.submitQuestion(payload);
    });
  };

  const allowedSubjectCodes = (data && data.map(s => s.TypeCode)) || [];
  const defaultAllowed = allowedSubjectCodes.includes(defaultSubject);
  return (
    <>
      <Form onSubmit={submit} theme="white">
        <FormFields
          form={form}
          data={data}
          name={user.FullName}
          defaultSubject={defaultAllowed ? defaultSubject : null}
        />
        <Form.Item>
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
      <div css={m.t32}>
        <RequiredFields />
      </div>
    </>
  );
};

AskUsForm.propTypes = {};

function mapStateToProps(state) {
  const {
    auth: { userinfo },
  } = state;
  return {
    user: userinfo,
  };
}

export default connect(
  mapStateToProps,
  { submitQuestion }
)(Form.create()(AskUsForm));
